import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import MobileDropdown from '../components/MobileDropdown';

import { setSelectedTab } from '../../../reducers/filtersSlice';
import { filterSvg } from '../../../../assets/svgIcons';

const MobileTab = ({ tab }) => {
  const { selectedTab } = useSelector((state) => state.filters);
  const dispatch = useDispatch();
  const isSelected = tab === selectedTab

  return (
    <div>
      <div className='vesta-button--filter vesta-flex-row-center vesta-gap-5 typo-bold-content vesta-white' onClick={() => dispatch(setSelectedTab(isSelected ? null : 'mobileFilters'))}>
        {filterSvg()}

        Filtrer
      </div>

      {isSelected && <MobileDropdown />}
    </div>
  )
};

export default MobileTab;
